<p>auth-callback works!</p>

<button type="button" class="btn btn-primary" (click)="getProfile()">Make API Request</button>